// extracted by mini-css-extract-plugin
export default {"container":"date-filter_container__UcFId","label":"date-filter_label__8gjuj","field":"date-filter_field__D4xu+","switch":"date-filter_switch__Pq3L3"};